import { render, staticRenderFns } from "./SmartCollection.vue?vue&type=template&id=0aaa93fc&"
import script from "./SmartCollection.vue?vue&type=script&lang=js&"
export * from "./SmartCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports